'use client';

import { Button } from '@shared/components/shadcn';
import { Warning } from '@shared/icons';
import type { ComponentProps } from 'react';
import { IconBadge } from '../IconBadge/IconBadge';

type FeedbackErrorProps = {
  primaryText: string;
  buttonText: string;
  onRetry: () => void;
} & ComponentProps<'div'>;

function FeedbackError({ primaryText, buttonText, onRetry, className, ...props }: FeedbackErrorProps) {
  return (
    <div className={`w-full h-full flex items-center justify-center ${className ?? ''}`} data-testid="feedback-error" {...props}>
      <div className="flex flex-col items-center gap-6 text-center max-w-sm px-6 py-12">
        <IconBadge icon={Warning} shapeType="custom-shape" />
        <div className="flex flex-col gap-1">
          <h5 className="heading-5">{primaryText}</h5>
        </div>
        <Button onClick={onRetry} data-testid="feedback-retry-button" className="w-full" data-track-name="Try Again">
          {buttonText}
        </Button>
      </div>
    </div>
  );
}

export { FeedbackError, type FeedbackErrorProps };
